/**
 * [Insider+] Deep-link path validation.
 */

import {
  INSIDER_PLUS_MEMBERSHIP_PAGE,
  INSIDER_PLUS_PAGE,
  LEGACY_INSIDER_PLUS_MEMBERSHIP_PAGE,
  LEGACY_INSIDER_PLUS_PAGE,
} from '../../constants/pages';

const MAX_PATH_LENGTH = 2048;

const LEGACY_PATH_MAP = [
  [LEGACY_INSIDER_PLUS_PAGE, INSIDER_PLUS_PAGE],
  [LEGACY_INSIDER_PLUS_MEMBERSHIP_PAGE, INSIDER_PLUS_MEMBERSHIP_PAGE],
];

// Maps a pre-rebrand pathname (/insider-plus[/...], /insider-plus-membership
// [/...]) to its Investor Hub equivalent, keeping any sub-path. Returns null
// for anything else. Matches whole path segments, so /insider-plus does not
// swallow /insider-plus-membership. Case-insensitive, like the router matching
// the old routes did, so /Insider-Plus still resolves.
export const getLegacyInsiderPlusPath = (pathname) => {
  if (typeof pathname !== 'string') return null;
  const lowerPathname = pathname.toLowerCase();
  const match = LEGACY_PATH_MAP.find(
    ([legacy]) =>
      lowerPathname === legacy || lowerPathname.startsWith(`${legacy}/`),
  );
  if (!match) return null;
  const [legacy, current] = match;
  return `${current}${pathname.slice(legacy.length)}`;
};

// Reject absolute URLs, protocol-relative URLs, and anything that could
// resolve outside INSIDER_PLUS_BASE_URL when concatenated into the iframe src.
export const isSafeInsiderPlusPath = (value) => {
  if (typeof value !== 'string') return false;
  if (value.length === 0 || value.length > MAX_PATH_LENGTH) return false;
  if (!value.startsWith('/')) return false;
  if (value.startsWith('//')) return false;
  if (value.includes('://')) return false;
  if (value.includes('\\')) return false;
  return true;
};
